/* eslint-disable */

class APIConstants {
  get sessions() {
    return {
      signup: `/signup`, // TODO: this ain't a function in the SessionsController :/
      create: `/api/sessions`
    }
  }

  get locations() {
    return {
      show: (id) => `/api/locations/${id}`,
      update: (id) => `/api/locations/${id}`,
      week: (id, today) => `/api/locations/${id}/week/${today}`,
      activities_in_time_period: (id, start_date, end_date) =>
        `/api/locations/${id}/activities_in_time_period`+
        `?start_date=${start_date}&end_date=${end_date}`,
      charge: (id) => `/api/locations/${id}/charge`,
      impact_stats: (id) => `/api/locations/${id}/impact_stats`,
      average_lbs_per_pickup: (id) => `/api/locations/${id}/average_lbs_per_pickup`,
      data_insights_by_month: (id) => `/api/locations/${id}/data_insights_by_month`,
      recipients_orgs_ordered_by_pounds_donated: (id, amount_of_recipients) => `/api/locations/${id}/recipients_orgs_ordered_by_pounds_donated?amount_of_recipients=${amount_of_recipients}`,
      active_tasks: (id) => `/api/locations/${id}/active_tasks`,
      tasks: (id, scheduledDate) => `/api/locations/${id}/tasks?scheduled-date=${scheduledDate}`,
      assigned_to_somebody: (id) => `/api/locations/${id}/assigned_to_somebody`,
      update_public_impact_enabled: (id) =>
        `/api/locations/${id}/update_public_impact_enabled`
    }
  }

  get business_locations() {
    return {
      create: `/api/business_locations`,
      tasks_csv: (id) => `/api/business_locations/${id}/tasks_csv`,
      update_update_plan_to_alc: (id) => `/api/business_locations/${id}/update_update_plan_to_alc`
    }
  }

  get recipient_locations() {
    return {
      create: `/api/recipient_locations`
    }
  }

  get roadie() {
    return {
      create: '/roadie'
    }
  }

  get doordash() {
    return {
      create: '/doordash',
    }
  }

  get activities() {
    return {
      update: (id) => `/api/activities/${id}`,
      create: `/api/activities`,
      add_cancellation_date: (id) => `/api/activities/${id}/add_cancellation_date`,
      add_end_date: (id) => `/api/activities/${id}/add_end_date`,
      holidays: '/api/holidays',
      officeClosedDates: ({ locationId, organizationId }) => organizationId
        ? `/api/office_closed_dates?organization_id=${organizationId}`
        : `/api/office_closed_dates?location_id=${locationId}`
    }
  }

  get twilio() {
    return {
      lookup: (phone_number) => `/twilio/lookup/${phone_number}`
    }
  }

  get admin() {
    return {
      businessList: `/api/users`,
      businessProfile: (id) => `/users/${id}`,
      todaysPickupTasks: '/api/todaysPickupTasks',
      todaysDropoffTasks: '/api/todaysDropoffTasks/',
      opTaskProfile: (id) => `/locations/${id}`,
    }
  }

  get users() {
    return {
      create: (type) => `/api/${type}s`,
      update: (id) => `/api/users/${id}`,
      charge: (id) => `/api/users/${id}/charge`,
      finish_signup: (id) => `/api/users/${id}/finish_signup`,
      send_notification_to_sales: '/api/users/send_notification_to_sales'
    }
  }

  get organizations() {
    return {
      update: (id) => `/api/organizations/${id}`,
      show: (id) => `/api/organizations/${id}`,
      tasks: (id, date) =>
        `/api/organizations/${id}/tasks?date=${date}`,
      impact_stats: (id) => `/api/organizations/${id}/impact_stats`,
      completed_tasks: (id, limit) =>
        `/api/organizations/${id}/completed_tasks?limit=${limit}`,
      locations: (id) => `/api/organizations/${id}/locations`,
    }
  }

  get business_organizations() {
    return {
      all_locations_task_csv: (id) =>
        `/api/business_organizations/${id}/all_locations_task_csv`,
      recipients_orgs_ordered_by_pounds_donated: (id, amount_of_recipients) => `/api/organizations/${id}/recipients_orgs_ordered_by_pounds_donated?amount_of_recipients=${amount_of_recipients}`,
      poundage_by_location: (id, limit) =>
        `/api/organizations/${id}/poundage_by_location?limit=${limit}`,
      poundage_by_location_by_month: (id, start_date, end_date, limit) =>
        `/api/organizations/${id}/poundage_by_location_by_month?start_date=${start_date}&end_date=${end_date}&limit=${limit}`,
    }
  }

  get recipient_organizations() {
    return {
      create_task_for_default_location: (id) =>
        `/api/recipient_organizations/${id}/create_task_for_default_location`,
    }
  }

  get business_regions() {
    return {
      invoices: (id) => `/api/business_regions/${id}/invoices`,
    }
  }

  get stripe() {
    return {
      customer_portal_url: (regionId) => `/stripe/customer_portal_url?region-id=${regionId}`,
      public_key: '/stripe/public_key',
    }
  }

  get onfleet() {
    return {
      drivers: '/onfleet/drivers'
    }
  }

  get drivers() {
    return {
      index: '/api/drivers'
    }
  }

  get tasks() {
    return {
      update: (id) => `/api/tasks/${id}`,
      update_completion_details: (id) =>
        `/api/tasks/${id}/update_completion_details`,
      pickups: (date, zone_id) =>
        `/api/tasks/pickups?date=${date}&zone_id=${zone_id}`,
      dropoffs: (date, zone_id) =>
        `/api/tasks/dropoffs?date=${date}&zone_id=${zone_id}`,
      succint_pickups: (date, zone_id) =>
        `/api/tasks/succint_pickups?date=${date}&zone_id=${zone_id}`,
      succint_dropoffs: (date, zone_id) =>
        `/api/tasks/succint_dropoffs?date=${date}&zone_id=${zone_id}`,
      update_pickups: (id) =>
        `/api/tasks/${id}/update_pickup_tasks`,
      update_dropoffs: (id) =>
        `/api/tasks/${id}/update_dropoff_tasks`,
      update_status: (id) =>
        `/api/tasks/${id}/update_status`,
      mark_as_failed: (id) =>
        `/api/tasks/${id}/mark_as_failed`,
      analyze_photo: (id) =>
        `/api/tasks/${id}/record-pickup/analyze-photo`,
      record_pickup_data: (id) =>
        `/api/tasks/${id}/record-pickup/store-data`,
    }
  }

  get logistics_agencies() {
    return {
      send_to_doordash: '/logistics_agencies/send_to_doordash',
      index: (zone_id) => `/logistics_agencies?zone_id=${zone_id}`
    }
  }

  get zones() {
    return {
        dropoff_tasks_on_date: (id, date) => `api/zones/${id}/dropoff_tasks_on_date?date=${date}`,
        locations: (id) => `api/zones/${id}/locations`,
        drivers: (id) => `api/zones/${id}/drivers`,
        all_zones: `api/zones/`
    }
  }

  get partner_assignments() {
    return {
      create: `/api/partner_assignments`,
      index: (partner_id, start_date, end_date) =>
        `/api/partner_assignments?partner_id=${partner_id}&`+
        `start_date=${start_date}&end_date=${end_date}`,
      update: (id) => `/api/partner_assignments/${id}`
    }
  }

  get automatically_accepted_activities_by_partners() {
    return {
      create: `/api/automatically_accepted_activities_by_partners`,
      destroy: (id) => `/api/automatically_accepted_activities_by_partners/${id}`
    }
  }

  get partners() {
    return {
      create_recipient_organization: (id) =>
        `/api/partners/${id}/create_recipient_organization`,
      impact_stats: (id) => `/api/partners/${id}/impact_stats`,
      drivers: (id) => `/api/partners/${id}/drivers`,
      tasks_csv: (id) => `/api/partners/${id}/tasks_csv`,
      update: (id) => `/api/partners/${id}`,
    }
  }
}

export default new APIConstants();
